export default [
  {
    title: 'breadcrumb.banAccount',
    route: 'list-banAccount',
    icon: 'ShieldOffIcon',
    resource: 'ban-account',
    action: 'read',
  },
]
